import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums';
import { CurrentUserService } from '@core/services';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss', './toolbar-mobile.component.scss'],
})
export class ToolbarComponent implements OnInit {
    currentUser: CurrentUser | null = null;
    roles = UserRoleEnum;

    isSwitchGroupDisplayed = false;
    readonly ordersUrl = environment.ordersUrl;

    constructor(private userService: CurrentUserService) {

    }

    async loadUser() : Promise<void>{
        this.userService.currentUser$.subscribe(user => {
            this.currentUser = user;
        });
    }

    async ngOnInit(): Promise<void> {
        await this.loadUser();
    }
}
